import React from 'react';

import { useLateResponsesReport, useLateResponsesReportCsv } from 'api';
import { useLateResponseFilters } from './hooks';
import { BaseReport } from '../..';

export const LateResponsesReport: React.FC = () => {
  useLateResponsesReport();
  const filters = useLateResponseFilters();
  const { mutate: exportCsv } = useLateResponsesReportCsv();

  return <BaseReport filters={filters} exportCsv={exportCsv} />;
};
